<app-header></app-header>
<section class="safety my-5">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="FAQs-content-child">
                <div class="FAQs-content-child">
                    <div class="etiquette-content-header-container">
                        <h2 class="etiquette-header">Safety and Trust</h2>
                    </div>
                    <div class="etiquette-text-container">
                        <p>As ParkUpp's Trust and Safety team, we are always thinking of ways we can help our community keep their cars safe and secure.</p>
                        <br />
                        <p>Whether you're a first time user or a stoked ParkUpp supporter, we want you to have a peace of mind.</p>
                        <br />
                        <p>Here are some tips for safety when using ParkUpp:</p>
                        <br />
                        <p>1. Read the parking owner's bio as they must include a report of their parkings.</p>
                        <br />
                        <p>2. Make friends with the owner</p>
                        <br />
                        <p>3. Make sure you've read all the amenities around the parking.</p>
                        <br />
                        <p>The ParkUpp community relies on trust and wed'd love your help in strengthening this reading our guidelines.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
